var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoldOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004529"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1008",
    d: "M20.5 10.5C20.5 16.0228 16.0228 20.5 10.5 20.5C4.97715 20.5 0.5 16.0228 0.5 10.5C0.5 4.97715 4.97715 0.5 10.5 0.5C16.0228 0.5 20.5 4.97715 20.5 10.5Z",
    stroke: "#FFAA5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1009",
    d: "M20.5 10.5C20.5 16.0228 16.0228 20.5 10.5 20.5C4.97715 20.5 0.5 16.0228 0.5 10.5C0.5 4.97715 4.97715 0.5 10.5 0.5C16.0228 0.5 20.5 4.97715 20.5 10.5Z",
    stroke: "#FFAA5B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5C20 15.7467 15.7467 20 10.5 20C5.25329 20 1 15.7467 1 10.5C1 5.25329 5.25329 1 10.5 1C15.7467 1 20 5.25329 20 10.5Z",
    fill: "#FFAA5B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.32 2.24C10.1882 2.14111 10 2.23519 10 2.4V3.5V4.6C10 4.76481 10.1882 4.85889 10.32 4.76L11.7867 3.66C11.8933 3.58 11.8933 3.42 11.7867 3.34L10.32 2.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9 12V7H10.5V11.25L14 13.33L13.28 14.54L9 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9 12V7H10.5V11.25L14 13.33L13.28 14.54L9 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1010",
    d: "M17.6334 12.8163C17.2082 14.1255 16.431 15.2925 15.3868 16.1894C14.3426 17.0863 13.0716 17.6785 11.7132 17.9012C10.3548 18.1239 8.96135 17.9684 7.68542 17.4518C6.4095 16.9353 5.30035 16.0775 4.47948 14.9725C3.65861 13.8675 3.15767 12.5579 3.03155 11.1872C2.90542 9.81644 3.15898 8.43743 3.76443 7.2012C4.36988 5.96497 5.30388 4.91921 6.46412 4.17848C7.62435 3.43774 8.96607 3.0306 10.3423 3.00166L10.364 4.03506C9.17747 4.06001 8.02067 4.41104 7.02033 5.04969C6.01999 5.68834 5.21472 6.58997 4.6927 7.65583C4.17069 8.72169 3.95208 9.91065 4.06083 11.0925C4.16957 12.2743 4.60147 13.4034 5.30921 14.3561C6.01695 15.3088 6.97324 16.0484 8.07332 16.4938C9.1734 16.9392 10.3748 17.0732 11.546 16.8812C12.7172 16.6892 13.813 16.1786 14.7133 15.4053C15.6136 14.632 16.2837 13.6259 16.6503 12.4971L17.6334 12.8163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1011",
    d: "M17.9648 9.77445C17.9223 9.33719 17.8415 8.9045 17.7232 8.48139L16.7278 8.75958C16.8297 9.12439 16.8994 9.49744 16.936 9.87444L17.9648 9.77445Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1015",
    d: "M17.8719 11.8802C17.9528 11.4484 17.9955 11.0103 17.9997 10.571L16.9661 10.5612C16.9625 10.9399 16.9256 11.3177 16.8559 11.69L17.8719 11.8802Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1012",
    d: "M17.3844 7.52434C17.1944 7.08477 16.9628 6.6644 16.6926 6.269L15.8392 6.8521C16.0721 7.19301 16.2718 7.55545 16.4356 7.93444L17.3844 7.52434Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1013",
    d: "M16.0401 5.44455C15.7288 5.10344 15.3867 4.79181 15.0181 4.51362L14.3954 5.33865C14.7132 5.57849 15.0082 5.84718 15.2766 6.14127L16.0401 5.44455Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1014",
    d: "M14.0593 3.8984C13.6697 3.68832 13.2622 3.51314 12.8417 3.37493L12.5189 4.35688C12.8815 4.47605 13.2329 4.62708 13.5688 4.80821L14.0593 3.8984Z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldOn);
export default __webpack_public_path__ + "static/media/holdOn.832473105c658059548c1c449bb8a6a2.svg";
export { ForwardRef as ReactComponent };